import MapboxDraw from '@mapbox/mapbox-gl-draw';
import React, { useRef } from 'react';
import { useControl } from 'react-map-gl';

function DrawControl(props, ref) {
  const drawRef = useRef();

  useControl(
    () => {
      const draw = new MapboxDraw(props);
      drawRef.current = draw;
      if (ref) ref.current = draw;
      return draw;
    },
    ({ map }) => {
      map.on('draw.create', props.onCreate);
      map.on('draw.update', props.onUpdate);
      map.on('draw.delete', props.onDelete);
      if (props.initialBoundry) drawRef.current.add(props.initialBoundry);
    },
    ({ map }) => {
      map.off('draw.create', props.onCreate);
      map.off('draw.update', props.onUpdate);
      map.off('draw.delete', props.onDelete);
    },
    {
      position: props.position
    }
  );

  return null;
}

DrawControl.defaultProps = {
  onCreate: () => {},
  onUpdate: () => {},
  onDelete: () => {}
};

export default React.forwardRef(DrawControl);

